export default {
  // 对话框标题
  title: "保存画布",

  // 表单标签
  canvasName: "画布名称",
  canvasDescription: "画布描述",

  // 占位符
  namePlaceholder: "请输入画布名称(必填)",
  descriptionPlaceholder: "请描述画布",

  // 按钮
  cancel: "取消",
  confirm: "确认",

  // 验证规则
  nameRequired: "画布名称为必填项",
};
